module.exports = __webpack_public_path__ + "assets/org-type-role.22fe7608.svg";